import { useQuery } from "@tanstack/react-query";
import { api, imgSrc } from "./api";

export const SLOTS = [
  ["Homepage", [
    ["hero", "Apertura — immagine a tutto schermo", "/images/hero-table.webp"],
    ["manifesto", "Manifesto — dettaglio macro della pietra", "/images/macro-vein.webp"],
    ["vision_1", "Una pietra. La tua visione — I. Il materiale", "/images/slab-marble.webp"],
    ["vision_2", "Una pietra. La tua visione — II. La lavorazione", "/images/process-work.webp"],
    ["vision_3", "Una pietra. La tua visione — III. L’oggetto", "/images/console.webp"],
    ["obj_1", "Oggetti — Tavoli da pranzo", "/images/hero-table.webp"],
    ["obj_2", "Oggetti — Tavolini da salotto", "/images/coffee-table.webp"],
    ["obj_3", "Oggetti — Tavolini laterali", "/images/side-table.webp"],
    ["obj_4", "Oggetti — Consolle", "/images/console.webp"],
    ["obj_5", "Oggetti — Oggetti scultorei", "/images/sculptural.webp"],
    ["obj_6", "Oggetti — Arredi su misura", "/images/bespoke.webp"],
    ["closing", "Chiusura — La pietra giusta cambia tutto", "/images/closing-stone.webp"],
  ]],
  ["Oggetti su misura", [
    ["bespoke_tables_1", "Tavoli — immagine grande", "/images/hero-table.webp"],
    ["bespoke_tables_2", "Tavoli — immagine piccola", "/images/coffee-table.webp"],
    ["bespoke_consoles", "Consolle", "/images/console.webp"],
    ["bespoke_sculptural", "Oggetti scultorei", "/images/sculptural.webp"],
    ["bespoke_commissions_1", "Commissioni su misura — immagine grande", "/images/bespoke.webp"],
    ["bespoke_commissions_2", "Commissioni su misura — immagine piccola", "/images/side-table.webp"],
  ]],
  ["Processo", [
    ["process_1", "Dopo fase 01 — Scelta del materiale", "/images/slab-quartzite.webp"],
    ["process_2", "Dopo fase 03 — Fattibilità e proposta", "/images/process-work.webp"],
    ["process_3", "Dopo fase 05 — Produzione", "/images/block-marble.webp"],
  ]],
  ["Chi siamo", [
    ["about", "Immagine principale", "/images/closing-stone.webp"],
  ]],
];

export const DEFAULTS = Object.fromEntries(SLOTS.flatMap(([, s]) => s.map(([k, , d]) => [k, d])));

export const useSiteImagesRaw = () => useQuery({
  queryKey: ["site-images"],
  queryFn: async () => {
    try { const { data } = await api.get("/site-images"); return data && typeof data === "object" ? data : {}; }
    catch { return {}; }
  },
  staleTime: 60000,
});

export const useSiteImages = () => {
  const { data, isLoading } = useSiteImagesRaw();
  return (key) => (isLoading ? "" : data?.[key] ? imgSrc(data[key]) : DEFAULTS[key]);
};
